import axios from 'axios'
import { useToast } from '@/composables/useToast'
import { reportClientError } from './errorReportService'
import { addHttpBreadcrumb } from './breadcrumbs'

const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL || 'http://localhost:3000',
})

api.interceptors.request.use((config) => {
  const user = JSON.parse(localStorage.getItem('user') ?? 'null')
  if (user?.bearer_token) {
    config.headers.Authorization = `Bearer ${user.bearer_token}`
  }
  config.headers['x-app-name'] = 'painel-adm'
  return config
})

api.interceptors.response.use(
  (res) => {
    addHttpBreadcrumb(res.config?.url, res.config?.method?.toUpperCase(), res.status)
    return res
  },
  (err) => {
    addHttpBreadcrumb(err.config?.url, err.config?.method?.toUpperCase(), err.response?.status)
    reportClientError({
      message:       err.message,
      stack:         err.stack,
      context:       'apiService.response',
      endpoint:      err.config?.url,
      method:        err.config?.method?.toUpperCase(),
      status_code:   err.response?.status,
      request_body:  err.config?.data,
      response_body: err.response?.data,
    })

    const isLoginRequest = err.config?.url?.includes('/login')
    if (err.response?.status === 401 && !isLoginRequest) {
      localStorage.removeItem('user')
      window.location.href = '/login'
      return Promise.reject(err)
    }

    const message = err.response?.data?.message
    if (message) {
      const { showToast } = useToast()
      showToast(message, 'error')
    }

    return Promise.reject(err)
  }
)

export default api
